import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class AuthService {
    private headers: Headers;
    private options;
    servetelLoginToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjExMjk2LCJpc3MiOiJodHRwczpcL1wvY3VzdG9tZXIuc2VydmV0ZWwuaW5cL3Rva2VuXC9nZW5lcmF0ZSIsImlhdCI6MTU5Mzc3MjMyNiwiZXhwIjoxODkzNzcyMzI2LCJuYmYiOjE1OTM3NzIzMjYsImp0aSI6Ing4THV0MXQzeUliM3VLNUUifQ.4yUzrjooiFHrTHGCR3c-z4kSmK0gftfaKgiEnrJVfyc';
    project :any;
    public projectId = new BehaviorSubject<any>(false);
    castprojectId = this.projectId.asObservable();
    base_uri: string='https://stgmformadminapi.dhwaniris.in/api/admin/v1/';
    constructor(private http: Http, @Inject('env') private env) { 
        this.base_uri = env.base_uri

    }

    setHttpHeaders() {
        this.castprojectId.subscribe(project =>{
            console.log(project)
            if(project){
                this.project = project
            }
            else{
                this.project = sessionStorage.getItem('projectId')
            }
        } );
        const organisation = sessionStorage.getItem('organisationId');
        // const project = '5ed4e7abbc5a013c69cc51d8';
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'x-access-token': this.getToken()
        });
        try {
            if (organisation) {
                headers = headers.append('organisation', organisation);
            }
            console.log(this.project)
            if (this.project && this.shouldAddProjectId()){
                headers = headers.append('project',this.project);
                // headers = headers.append('project','5ed4e7abbc5a013c69cc51d8');
            }
            

        } catch (error) {
            console.error(error);
        }
        return { headers };
    }

    setHttpBasicHeaders() {
        const organisation = sessionStorage.getItem('organisationId');
        const projectId = sessionStorage.getItem('projectId');

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'x-access-token': this.getToken()
        });
        if (organisation) {
            headers = headers.append('organisation', organisation);
        }
        if (projectId) {
            headers = headers.append('project', projectId);
        }
        return { headers };
    }

    setHeaders(token='') {
        // Setting headers..
        const organisation = sessionStorage.getItem('organisationId');
        const project = sessionStorage.getItem('projectId');

        this.headers = new Headers({
            'Content-Type': 'application/json',
            'x-access-token': token ? token : this.getToken()
        });
        // let headers = HttpHeaders({})
        if (organisation) {
            this.headers.set('organisation', organisation);
        }
        if (project) {
            this.headers.set('project', project);
        }
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    setHeadersWithBody(token='', obj) {
        // Setting headers..
        const organisation = sessionStorage.getItem('organisationId');
        const project = sessionStorage.getItem('projectId');

        this.headers = new Headers({
            'Content-Type': 'application/json',
            'x-access-token': token ? token : this.getToken()
        });
        // let headers = HttpHeaders({})
        if (organisation) {
            this.headers.set('organisation', organisation);
        }
        if (project) {
            this.headers.set('project', project);
        }
        this.options = new RequestOptions({ headers: this.headers, body: {...obj} });
        return this.options;
    }

    setHeadersWithFormId(id) {
        // Setting headers..
        const organisation = sessionStorage.getItem('organisationId');
        const project = id
        this.headers = new Headers({
            'Content-Type': 'application/json',
            'x-access-token': this.getToken()
        });
        if (organisation) {
            this.headers.set('organisation', organisation);
        }
        if (project) { 
            
         }
            this.headers.set('project', project);
      
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }
    setCustomHeaders(token) {
        // Setting headers..
        const organisation = sessionStorage.getItem('organisationId');
        const project = sessionStorage.getItem('projectId');
        this.headers = new Headers({
            'Content-Type': 'application/json',
            'x-access-token': token,
            'Authorization' : token
        });
        if (organisation) {
            this.headers.set('organisation', organisation);
        }
        if (project) {
            this.headers.set('project', project);
        }
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }
    setBasicHeaders() {
        // Setting headers..

        this.headers = new Headers({
            'Content-Type': 'application/json',
            'x-access-token': this.getToken(),
            organisation: sessionStorage.getItem('organisationId') || ''
        });
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    getToken() {
        // Get Token..
        return sessionStorage.getItem('token');
    }

    getProject() {
        let project = sessionStorage.getItem('projectId');
        return project && project == 'null' ? project : '';
    }

    downloadCSVWithDate(key, from = '', to = '') {
        let organisationId = sessionStorage.getItem('organisationId');
        return (
            this.base_uri +
            '/' +
            key +
            '?token=' +
            this.getToken() +
            '&from=' +
            from +
            '&to=' +
            to +
            '&project=' +
            this.getProject() +
            `&organisation=${organisationId}`
        );
    }
    downloadCSVWithDateSurveyor(key, from = '', to = '',partner) {
        let organisationId = sessionStorage.getItem('organisationId');
        let project = sessionStorage.getItem('projectId');
        return (
            this.base_uri +
            '/' +
            key +
            '?token=' +
            this.getToken() +
            '&from=' +
            from +
            '&to=' +
            to +
            `&project=${project}` +
            `&organisation=${organisationId}`+
            `&partner=${partner}`
        );
    }
    bulkImageDownload(key,
        from = '',
        to = '',
        state = '',
        district = '',
        block = '',
        gramPanchayat = '',
        village = '',
        hamlet = '',
        partner = '',
        device = '',
        type = '',
        questions = '') {
        let organisationId = sessionStorage.getItem('organisationId');
        let project = sessionStorage.getItem('projectId');
        return (
            this.base_uri +
            key +
            '?token=' +
            this.getToken() +
            '&project=' +
            project +
            `&organisation=${organisationId}` +
            '&from=' +
            from +
            '&to=' +
            to +
            '&state=' +
            state +
            '&district=' +
            district +
            '&block=' +
            block +
            '&gramPanchayat=' +
            gramPanchayat +
            '&village=' +
            village +
            '&hamlet=' +
            hamlet+
            '&type=' +
            type +
            '&partner=' +
            partner +
            '&device=' +
            device +
            '&questions=' +
            questions
        );
    }

    downloadCSVFormDataWithCustomFilters(
        key,
        formId,
        from = '',
        to = '',
        state = '',
        district = '',
        block = '',
        gramPanchayat = '',
        village = '',
        hamlet = '',
        partner = '',
        device = '',
        type = '',
        questions = '',
        flatMember = '',
        configurationalColumn = '',
        shortKey='',
        instructions='',
        headerOptionCode='',
        labelLinkedQuestions='',
        draftData:any = '',
        isBulkUploadFormat = '',
        fillRowsForLoopingQuestion=''
    ) {
        let project = sessionStorage.getItem('projectId');
        let organisationId = sessionStorage.getItem('organisationId');
      
        return (
            this.base_uri +
            key +
            '?project=' +
            project +
            '&token=' +
            this.getToken() +
            `&organisation=${organisationId}` +
            '&formId='+ formId +
            '&from=' +
            from +
            '&to=' +
            to +
            '&state=' +
            state +
            '&district=' +
            district +
            '&block=' +
            block +
            '&gramPanchayat=' +
            gramPanchayat +
            '&village=' +
            village +
            '&hamlet=' +
            hamlet +
            '&type=' +
            type +
            '&partner=' +
            partner +
            '&device=' +
            device +
            '&questions=' +
            questions + '&flatMember=' + flatMember + '&configurationalColumn=' + configurationalColumn
            + '&shortKey=' +  shortKey + '&instructions=' + instructions+'&headerOptionCode='+headerOptionCode+'&labelLinkedQuestions='+labelLinkedQuestions+'&draftData='+draftData + '&bulkUploadFormat=' + isBulkUploadFormat + '&fillRowsForLoopingQuestion='+ fillRowsForLoopingQuestion
           
        );
       
    }

    public getHttpClientParams(obj: {}) {
        let params = new HttpParams();
        if (obj) {
            Object.keys(obj).forEach(key => {
                if (obj[key] || obj[key] === 0) {
                    params = params.set(key, obj[key]);
                }
            });
        }
        return params;
    }

    private shouldAddProjectId() {
        if (window.location.pathname.includes('census/view')) {
            return false;}
            else{
                return true;
            }
    }

    setServetelHeaders() {
        // Setting headers..
        const organisation = sessionStorage.getItem('organisationId');
        const project = sessionStorage.getItem('projectId');
        this.headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });

        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    setServetelGetAgentHeaders(token) {
        // Setting headers..
        this.headers = new Headers({
            'Accept': 'application/json',
            'Authorization': token,
        });

        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    setHttpHeadersFormData() {
        // 'Content-Type': 'multipart/form-data;boundary="boundary"',
        
        const organisation = sessionStorage.getItem('organisationId');
        const project = sessionStorage.getItem('projectId');
        let headers = new HttpHeaders({
            // 'Content-Type': 'multipart/form-data',
            'x-access-token': this.getToken(),
            'Accept': 'application/json'
        });
        try {
            if (organisation) {
                headers = headers.append('organisation', organisation);
            }
            if (project && this.shouldAddProjectId())
                headers = headers.append(
                    'project',
                    sessionStorage.getItem('projectId')
                );
        } catch (error) {
            console.error(error);
        }
        return { headers };
    }
}
